/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BoothDto } from '../../models/booth-dto';
import { BoothUpdateDto } from '../../models/booth-update-dto';

export interface FloorPlanAdminControllerUpdateBoothV1$Params {
  id: string;
      body: BoothUpdateDto
}

export function floorPlanAdminControllerUpdateBoothV1(http: HttpClient, rootUrl: string, params: FloorPlanAdminControllerUpdateBoothV1$Params, context?: HttpContext): Observable<StrictHttpResponse<BoothDto>> {
  const rb = new RequestBuilder(rootUrl, floorPlanAdminControllerUpdateBoothV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BoothDto>;
    })
  );
}

floorPlanAdminControllerUpdateBoothV1.PATH = '/api/v1/floor-plans/admin/booth/{id}';
